import { Client } from '../../types/menu';
import useHelpers from '../../hooks/utility/useHelpers';
import { Button } from 'antd';
import React from 'react';

type Props = {
  data: Client.Product;
  onAdd: (product: Client.Product) => void;
};

export default function Product({ data, onAdd }: Props) {
  const { formatCurrency } = useHelpers();

  return (
    <div className="flex justify-between mt-lg">
      <div className="my-auto">
        <p>{data.name}</p>
        {Boolean(data.description) && (
          <p className="mt-sm text-sm text-gray-300">{data.description}</p>
        )}
      </div>
      <div className="flex gap-sm h-fit">
        {data.is_available ? (
          <>
            <p className="h-fit my-auto">{formatCurrency(data.price)}</p>
            <Button type="primary" onClick={() => onAdd(data)}>
              Order
            </Button>
          </>
        ) : (
          <p className="text-brand-primary w-max">Sold out!</p>
        )}
      </div>
    </div>
  );
}
